/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaScorrimentoForm { 
    /**
     * Budget disponibile visto in anteprima (assente se il bando non ha budget)
     */
    disponibile_importo_atteso?: number;
    /**
     * Posti disponibili visti in anteprima (assenti se il bando non ha un tetto di beneficiari)
     */
    disponibile_posti_atteso?: number;
}

